import React from 'react'
import { HeaderContent } from '../styles'
import { Field } from '../../../../components/Input/CheckboxInput/styles'
import { FaChevronUp, FaChevronDown } from 'react-icons/fa'

export interface ListItemProps {
  column: any
  index: number
  isActive: boolean
  onSelectAllValues: (check: boolean) => void
  onSubmitOrder: (name: string, order: string) => void
}

const getColumnWidth = (idx: number) => {
  switch (idx) {
    case 0: return '38%'
    case 1: return '16%'
    case 2: return '22%'
    case 3: return '12%'
    case 4: return '12%'
    default: return '20%'
  }
}

const getColumnAlign = (idx: number) => {
  if (idx === 4) return 'flex-end'
  return 'flex-start'
}

const HeaderTable: React.FunctionComponent<ListItemProps> = ({
  column,
  index,
  onSubmitOrder,
  onSelectAllValues,
  isActive,
}) => {
  const [order, setOrder] = React.useState('asc')

  React.useEffect(() => {
    onSubmitOrder(column.sort, order)
  }, [order])

  const toggleOrder = () => {
    setOrder((old) => (old === 'asc' ? 'desc' : 'asc'))
  }

  return (
    <div
      key={column._id}
      style={{
        display: 'inline-block',
        padding: '0 8px',
        width: getColumnWidth(index),
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: getColumnAlign(index),
          gap: 6,
          cursor: 'pointer',
          userSelect: 'none',
        }}
        onClick={toggleOrder}
      >
        {index === 0 && isActive && (
          <Field
            type='checkbox'
            onChange={(e) => {
              e.stopPropagation()
              onSelectAllValues(e.target.checked)
            }}
            style={{ marginRight: 6, cursor: 'pointer' }}
          />
        )}
        <HeaderContent.BreadName>{column.name}</HeaderContent.BreadName>
        <span style={{ color: '#94a3b8', display: 'flex', alignItems: 'center' }}>
          {order === 'asc' ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
        </span>
      </div>
    </div>
  )
}

export default HeaderTable
